import { FormInstance } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

import FieldInputSimpleBuffer from '../../components/fieldInputSimpleBuffer';
import FieldNameInHeader from '../../components/fieldNameInHeader';
import useAccess from '../../hooks/useAccess';
import { RootState } from '../../store';
import { TaskBoardTaskAssignee } from '../../taskBoard/component/taskBoardTaskAssignee';
import { ItemTaskType } from '../../types';

interface IDrawerPanelLabel {
    form: FormInstance<ItemTaskType>;
}

const DrawerPanelLabel: React.FC<IDrawerPanelLabel> = ({ form }) => {
    const isAccessToEditTask = useAccess(['schedule-task.create', 'schedule-task.edit', 'schedule-task.manage']);

    const currentTask = useSelector<RootState, ItemTaskType | null>((state) => state.calendar.currentTask);

    return (
        <FieldNameInHeader<ItemTaskType>
            form={form}
            field={
                <FieldInputSimpleBuffer
                    nameField={'name'}
                    rulesField={[{ required: true, message: 'Please input item name!' }]}
                />
            }
            fieldAvatar={<TaskBoardTaskAssignee userId={currentTask?.owner_task_id} />}
            valueNameField={currentTask?.name}
            isShowEditButton={isAccessToEditTask}
        />
    );
};

export default DrawerPanelLabel;
